const AiToolRoutes = [
    {
        path: '/cloth-swap-free',
        name: 'ClothSwap',
        component: () => import(/* webpackChunkName: "clothSwap" */'@/views/ai-tool/ClothSwap.vue')
    }
]


export default AiToolRoutes;


